<script>
export default {
  props: {
    news: {
      type: Object,
    },
  },
};
</script>

<template>
  <div>
    <router-link
      :to="{name: 'userpage', params: {type: 'profile', id: news.textParams[0]}}"
    >{{news.textParams[1]}}</router-link>
    {{$t('news.template.opinion.updatedAndMadePublicByMember.p1')}}
    {{news.textParams[2]}}
    {{$t('news.template.opinion.updatedAndMadePublicByMember.p2')}}
    {{news.textParams[3]}}
    {{$t('news.template.opinion.updatedAndMadePublicByMember.p3')}}
    {{news.textParams[4]}}
    {{news.textParams[5]}}
    {{news.textParams[6]}}
    {{news.textParams[7]}}
    {{news.textParams[8]}}
    {{news.textParams[9]}}
    {{news.textParams[10]}}
    {{$t('news.template.opinion.updatedAndMadePublicByMember.p4')}}
    {{news.textParams[11]}}
    {{$t('news.template.opinion.updatedAndMadePublicByMember.p5')}}
    "<router-link :to="{name: 'OpinionView', params: {
      hash: news.textParams[12]
    }}">
    {{news.textParams[13]}}
    </router-link>"
    {{$t('news.template.opinion.updatedAndMadePublicByMember.p6')}}
  </div>
</template>
